<template>
	<div data-tour-scope="setting-store">
		<v-main>
			<v-container fluid class="st-page">
				<v-card outlined elevation-0 class="mb-4">
					<v-toolbar flat class="border_bottom" shaped>
						<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.subsetting.store') }}</v-toolbar-title>
						<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
						<v-spacer></v-spacer>
						<v-btn depressed color="primary" data-tour="save" @click="confirm"><v-icon left>mdi-content-save-outline</v-icon>Salva</v-btn>
					</v-toolbar>
				</v-card>

				<!-- riepilogo -->
				<v-card outlined class="st-summary mb-4">
					<div class="st-avatar">
						<img v-if="form.logo" :src="form.logo" alt="" />
						<v-icon v-else color="primary">mdi-storefront-outline</v-icon>
					</div>
					<div class="st-main">
						<div class="st-title">{{ form.name || 'Negozio senza nome' }}</div>
						<div class="st-sub">
							<span>{{ form.website || 'Sito non indicato' }}</span>
							<span class="mx-1">·</span>
							<span>{{ form.email || 'Email non indicata' }}</span>
						</div>
						<div class="st-chips">
							<v-chip x-small label :color="spedizioneCompleta ? 'success' : undefined" :outlined="!spedizioneCompleta" :text-color="spedizioneCompleta ? 'white' : undefined">
								<v-icon left x-small>mdi-truck-outline</v-icon>{{ spedizioneCompleta ? 'Indirizzo di spedizione completo' : 'Indirizzo di spedizione da completare' }}
							</v-chip>
							<v-chip x-small label :color="fatturazioneCompleta ? 'success' : undefined" :outlined="!fatturazioneCompleta" :text-color="fatturazioneCompleta ? 'white' : undefined">
								<v-icon left x-small>mdi-receipt-text-outline</v-icon>{{ fatturazioneCompleta ? 'Dati di fatturazione completi' : 'Dati di fatturazione da completare' }}
							</v-chip>
						</div>
					</div>
				</v-card>

				<SectionCard title="Negozio" icon="mdi-storefront-outline" class="mb-4" data-tour="main">
					<v-row class="st-fields">
						<v-col cols="12" md="4">
							<v-text-field v-model="form.name" label="Nome" outlined dense hide-details="auto" :error-messages="messages.name"></v-text-field>
						</v-col>
						<v-col cols="12" md="4">
							<v-text-field v-model="form.website" label="Sito web" placeholder="https://" prepend-inner-icon="mdi-web" outlined dense hide-details="auto" :error-messages="messages.website">
								<template v-slot:append>
									<v-btn v-if="linkSito" x-small icon :href="linkSito" target="_blank" rel="noopener" title="Apri il sito in una nuova scheda">
										<v-icon small>mdi-open-in-new</v-icon>
									</v-btn>
								</template>
							</v-text-field>
						</v-col>
						<v-col cols="12" md="4">
							<v-text-field v-model="form.email" label="Email" prepend-inner-icon="mdi-email-outline" outlined dense hide-details="auto" :error-messages="messages.email"></v-text-field>
						</v-col>
					</v-row>
				</SectionCard>

				<v-row class="st-cols">
					<v-col cols="12" md="6">
						<SectionCard title="Spedizione / ritiro in sede" icon="mdi-truck-outline" data-tour="shipping" class="st-card">
							<v-row class="st-fields">
								<v-col cols="12">
									<v-text-field v-model="form.ShippingAddress.Name" label="Nome" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="12">
									<v-text-field v-model="form.ShippingAddress.Address" label="Indirizzo" prepend-inner-icon="mdi-map-marker-outline" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6">
									<v-text-field v-model="form.ShippingAddress.City" label="Città" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="6" sm="3">
									<v-text-field v-model="form.ShippingAddress.Province" label="Provincia" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="6" sm="3">
									<v-text-field v-model="form.ShippingAddress.Cap" label="CAP" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="12" sm="4">
									<v-text-field v-model="form.ShippingAddress.Country" label="Paese (es. IT)" counter="2" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="12" sm="4">
									<v-text-field v-model="form.ShippingAddress.Phone" label="Telefono" prepend-inner-icon="mdi-phone-outline" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="12" sm="4">
									<v-text-field v-model="form.ShippingAddress.MobilePhone" label="Cellulare" prepend-inner-icon="mdi-cellphone" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="12">
									<v-text-field v-model="form.ShippingAddress.Mail" label="Email" prepend-inner-icon="mdi-email-outline" outlined dense hide-details="auto"></v-text-field>
								</v-col>
							</v-row>
						</SectionCard>
					</v-col>
					<v-col cols="12" md="6">
						<SectionCard title="Fatturazione" icon="mdi-receipt-text-outline" data-tour="invoice" class="st-card">
							<v-row class="st-fields">
								<v-col cols="12">
									<v-text-field v-model="form.InvoiceAddress.Company" label="Ragione sociale" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="12">
									<v-text-field v-model="form.InvoiceAddress.Address" label="Indirizzo" prepend-inner-icon="mdi-map-marker-outline" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6">
									<v-text-field v-model="form.InvoiceAddress.City" label="Città" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="6" sm="3">
									<v-text-field v-model="form.InvoiceAddress.Cap" label="CAP" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="6" sm="3">
									<v-text-field v-model="form.InvoiceAddress.Province" label="Provincia" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="12" sm="4">
									<v-text-field v-model="form.InvoiceAddress.Country" label="Paese" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="12" sm="4">
									<v-text-field v-model="form.InvoiceAddress.Vat" label="Partita IVA" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="12" sm="4">
									<v-text-field v-model="form.InvoiceAddress.Fiscalcode" label="Codice fiscale" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="12" sm="4">
									<v-text-field v-model="form.InvoiceAddress.Reference" label="Referente" prepend-inner-icon="mdi-account-outline" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="12" sm="4">
									<v-text-field v-model="form.InvoiceAddress.Sdi" label="Codice SDI" outlined dense hide-details="auto"></v-text-field>
								</v-col>
								<v-col cols="12" sm="4">
									<v-text-field v-model="form.InvoiceAddress.Pec" label="PEC" outlined dense hide-details="auto"></v-text-field>
								</v-col>
							</v-row>
						</SectionCard>
					</v-col>
				</v-row>

				<WorkingHoursCard v-if="form.working_hours" v-model="form.working_hours" />

				<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
					<span v-html="snackbar.text"></span>
					<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
				</v-snackbar>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import Vue from 'vue';

import moment from 'moment';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import axios from 'axios';

import VueLodash from 'vue-lodash';
import lodash from 'lodash';

import { uuid } from 'vue-uuid';
import VueClipboard from 'vue-clipboard2';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createStoreTourSteps } from './store-tour';
import SectionCard from '@/components/core/SectionCard.vue';
import WorkingHoursCard, { weekForForm, invalidDays } from './components/WorkingHoursCard.vue';

export default {
	props: ['FunctionParent'],
	name: 'Edit',
	setup() {
		return { tour: useTour(createStoreTourSteps()) };
	},
	beforeDestroy() {
		this.tour.stop();
	},
	data() {
		return {
			form: {},
			customersType: [
				{ name: 'Private', value: 'private' },
				{ name: 'Company', value: 'company' },
			],
			componentKey: 0,

			uuid: '',
			// trhree view
			items: [],
			open: [1, 2],
			search: null,
			caseSensitive: false,
			selectionType: 'independent',
			subCont: '',
			subKey: '',

			selection: [],

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			statusCategory: [
				{ text: 'No', value: false },
				{ text: 'Yes', value: true },
			],
			messages: {
				// chiavi dei campi del negozio da subito: assegnate dopo non sarebbero reattive
				name: '',
				website: '',
				email: '',
				trans: [],
				status: '',
				position: '',
				brand: '',
				variants: [
					{
						variants: [],
						sku: '',
						ean: '',
						qt: 0,
						buy: 0,
						unit: '',
						qtunit: 1,
						currency: '',
						sell: 0,
						pricevat: 0,
						uuid: '',
					},
				],
			},

			show1: false,
			languages: [],
			langDefault: '',
			selected: [],
			loading: false,
			selectListings: [],
		};
	},
	watch: {},

	components: {
		TourOverlay,
		SectionCard,
		WorkingHoursCard,
	},
	async created() {
		await this.resetForm();
	},
	async mounted() {
		//this.form.OldStatus = this.getOrder.Status;
		//   this.resetForm();
		this.uuid = uuid.v4();

		this.subKey = '';
		this.subCont = '';
		await this.getProfile({});
		// senza lingue (profili vecchi nati incompleti) la pagina deve comunque riempire il form:
		// col form vuoto un Salva cancellerebbe nome, indirizzi e orari del profilo
		this.languages = _.filter(this.getSettings.languages, { is_active: true });
		this.langDefault = _.get(_.find(this.getSettings.languages, { default: true }), 'lang', 'it');
		this.languages = _.orderBy(this.languages, ['default'], ['desc']);
		this.form._id = this.getSettings._id;
		this.form.logo = this.getSettings.logo;
		this.form.phone = this.getSettings.phone;
		this.form.name = this.getSettings.name;
		this.form.email = this.getSettings.email;
		this.form.website = this.getSettings.website;
		this.form.working_hours = weekForForm(this.getSettings.working_hours);
		this.form.InvoiceAddress = this.getSettings.InvoiceAddress
			? this.getSettings.InvoiceAddress
			: {
					Company: '',
					Address: '',
					City: '',
					Cap: '',
					Province: '',
					Country: '',
					Vat: '',
					Fiscalcode: '',
					Sdi: '',
					Pec: '',
					Reference: '',
			  };
		this.form.ShippingAddress = this.getSettings.ShippingAddress
			? this.getSettings.ShippingAddress
			: {
					Name: '',
					Address: '',
					City: '',
					Province: '',
					Country: '',
					Phone: '',
					Cap: '',
					MobilePhone: '',
					Mail: ''
			  };
	},
	computed: {
		...mapGetters({
			getPreload: 'settings/getPreload',
			getErrors: 'settings/getErrors',
			getMessages: 'settings/getMessages',
			getIndex: 'orders/getIndex',
			getUrl: 'settings/getUrl',
			getToken: 'profile/getToken',
			getItem: 'customers/getItem',
			//'getCategoriesTree':'categories/getCategoriesTree',
			//'getCategoriesChildrean':'categories/getCategoriesChildrean',
			getSettings: 'settings/getSetting',
			getSubDialog: 'settings/getSubDialog',
		}),
		// link apribile dal campo Sito web (aggiunge https:// se manca)
		linkSito() {
			const url = (this.form.website || '').trim();
			if (!url) return '';
			return /^https?:\/\//i.test(url) ? url : `https://${url}`;
		},
		spedizioneCompleta() {
			const a = this.form.ShippingAddress || {};
			return !!(a.Address && a.City && a.Cap && a.Country);
		},
		fatturazioneCompleta() {
			const a = this.form.InvoiceAddress || {};
			return !!(a.Company && a.Address && a.City && a.Cap && (a.Vat || a.Fiscalcode));
		},
		filter() {
			return this.caseSensitive ? (item, search, textKey) => item[textKey].indexOf(search) > -1 : undefined;
		},
	},
	methods: {
		...mapMutations({
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSubDialog: 'settings/setSubDialog',
			/*'setSnackbar':'snackbars/setSnackbar',
            'setColor':'snackbars/setColor',
            'setMultiline':'snackbars/setMultiline',
            'setSnackTimeout':'snackbars/setSnackTimeout',
            'setVertical':'snackbars/setVertical',
            'setText':'snackbars/setText',*/
			setLogout: 'profile/setLogout',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setSnackbar: 'snackbars/setSnackbar',
		}),
		...mapActions({
			saveData: 'users/saveData',
			getProfile: 'profile/getProfile',
			getDetailItem: 'customers/getDetailItem',
			updateData: 'settings/updateData',
			getListings: 'listings/getListings',
			setSettings: 'settings/updateData',
		}),
		formatData(data) {
			return moment(data).format('DD/MM/YYYY');
		},
		propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.variantsSettings = [];
			_.forEach(this.getSettings.variants, variant => {
				var value = _.find(variant.trans, { lang: this.langDefault }).name;
				this.variantsSettings = [{ id: variant.id, variant: value }, ...this.variantsSettings];
			});
			_.forEach(this.getSettings.attributes, attribute => {
				var value = _.find(attribute.trans, { lang: this.langDefault }).name;
				this.attributesSettings = [{ id: attribute.id, attribute: value }, ...this.attributesSettings];
			});
			if (_.isNumber(this.setVariant)) {
				var posizione = this.getSettings.variants[this.setVariant];

				var find = _.find(this.listCombines, { id: posizione.id });

				find.values = posizione.values;
				this.setVariant = '';
			}
			if (_.isNumber(this.setAttribute)) {
				var posizione = this.getSettings.attributes[this.setAttribute];
				//console.log(posizione);
				var find = _.find(this.listAttrCombines, { id: posizione.id });

				find.values = posizione.values;
				this.setAttribute = '';
			}
			this.operation = '';
		},
		async resetForm() {
			this.form = {
				// orari di lavoro: la chiave c'e' da subito, assegnata dopo non sarebbe reattiva
				working_hours: weekForForm([]),
				logo: '',
				phone: '',
				name: '',
				website: '',
				email: '',
				ShippingAddress: {
					Name: '',
					Address: '',
					City: '',
					Province: '',
					Country: '',
					Phone: '',
					Cap: '',
					Latitude: '',
					Longitude: '',
					Mail: '',
					MobilePhone: ''
				},
				InvoiceAddress: {
					Company: '',
					Address: '',
					City: '',
					Cap: '',
					Province: '',
					Country: '',
					Vat: '',
					Fiscalcode: '',
					Sdi: '',
					Pec: '',
					Reference: '',
				},
			};
		},

		close() {
			this.setDialog(false);
		},
		async confirm() {
			this.messages.name = '';
			this.messages.lastname = '';
			this.messages.email = '';

			this.errors = [];

			// form mai caricato dal profilo: salvarlo azzererebbe nome, indirizzi e orari
			if (!this.form._id) {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Dati del negozio non caricati: ricarica la pagina prima di salvare';
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 6000;
				this.snackbar.snackbar = true;
				return;
			}

			const giorni = invalidDays(this.form.working_hours);
			if (giorni.length) {
				this.snackbar.color = 'error';
				this.snackbar.text = `Controlla gli orari di lavoro: ${giorni.join(', ')}`;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 6000;
				this.snackbar.snackbar = true;
				return;
			}

			let url = 'profile/update/store';
			// this.form.ShippedTime = this.parseDateShipment;
			var payload = this.form;
			this.setPreload(true);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.setSettings(data.data);
					//this.$emit('event')
					//this.$emit('message', "Operazione effettuata con  successo")
				})
				.then(() => {
					//this.
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					//this.resetForm();
					this.errors = [];

					this.messages = {
						name: '',
						website: '',
						email: '',
						trans: [],
					};

					//console.log('Main Vue destroyed')

					this.setDialog(false);
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							console.log(errors);

							var testo = '';
							errors.forEach(value => {
								//   console.log(value.msg);
								var spliterror = _.split(value.param, '.');
								this.$set(this.messages, spliterror[1] || spliterror[0], value.msg);
								testo += value.msg + ' <br>';
							});
						}

						this.snackbar.color = 'error';
						//this.snackbar.text = this.$vuetify.lang.t(`$vuetify.errors.${err.response.data.message}`);
						this.snackbar.text = testo;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
					// anche senza risposta dal server (rete, timeout) il preload va spento
					this.setPreload(false);
				});
		},
	},
};
</script>

<style scoped>
.st-summary {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 12px 20px;
	padding: 12px 16px;
	border-radius: 10px !important;
}
.st-avatar {
	flex: 0 0 52px;
	width: 52px;
	height: 52px;
	border-radius: 10px;
	border: 1px solid #e1e7ef;
	background: #f3f6fa;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
}
.st-avatar img {
	width: 100%;
	height: 100%;
	object-fit: contain;
	padding: 4px;
	background: #fff;
}
.st-main {
	flex: 1 1 240px;
	min-width: 0;
}
.st-title {
	font-size: 17px;
	font-weight: 600;
	color: #1f2d3d;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.st-sub {
	font-size: 13px;
	color: #5f6b7a;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.st-chips {
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
	margin-top: 4px;
}
/* le due card affiancate prendono la stessa altezza */
.st-card {
	height: 100%;
}
/* 16px tra le card, 8px per lato tra i campi (come nelle schede) */
.st-cols {
	margin-top: 0;
	margin-bottom: 0;
}
.st-cols > [class*='col'] {
	padding-top: 0;
	padding-bottom: 16px;
}
.st-fields {
	margin: 0;
}
.st-fields > [class*='col'] {
	padding: 8px;
}
</style>

